import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import lifeInsuranceService from "../../../../api/LifeInsurance/LifeInsuranceService";
export default class UpdateLifeInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvailableLifeInsurances: [],
      selectedLifeInsurance: {
        id: null,
        description: "",
        ar_description: "",
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllLifeInsurances();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };
  getAllLifeInsurances = () => {
    this.setState({ allAvailableLifeInsurances: [] });
    lifeInsuranceService
      .getAllInsurances()
      .then((res) => {
        res.data.map((description, i) => {
          console.log("category:", description);
          return this.setState({
            allAvailableLifeInsurances: [
              ...this.state.allAvailableLifeInsurances,
              {
                key: i + 1,
                id: description.id,
                description: description.description,
                ar_description: description.ar_description,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  selectedLifeInsurance = () => {
    return this.state.allAvailableLifeInsurances?.map((description) => {
      return <option value={description.id}>{description.description}</option>;
    });
  };

  onSelectLifeInsurance = (e) => {
    this.state.allAvailableLifeInsurances.map(
      (description) =>
        e.target.value === description.id &&
        this.setState({
          selectedLifeInsurance: {
            id: description.id,
            description: description.description,
            ar_description: description.ar_description,
          },
        })
    );
  };

  updateLifeInsurance = () => {
    console.log("selected category", this.state.selectedLifeInsurance);
    lifeInsuranceService.editInsurance(this.state.selectedLifeInsurance.id, {
      description: this.state.selectedLifeInsurance.description,
      ar_description: this.state.selectedLifeInsurance.ar_description,
    });
    document.getElementById("description").value = "";
    document.getElementById("ar_description").value = "";
    toast.success(`List Insurance Updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllLifeInsurances();
  };

  onChangeLifeInsuranceData = (e) => {
    let selectedLifeInsurance = this.state.selectedLifeInsurance;
    selectedLifeInsurance[e.target.name] = e.target.value;
    this.setState({ selectedLifeInsurance });
  };

  render() {
    let selectedLifeInsurance = this.selectedLifeInsurance();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update Life Insurance</h5>
          </Col>
        </Row>
        <Row>
          <Col md="7" className="pt-3">
            <div class="form-group" id="role">
              <select
                class="form-control"
                id="role"
                onChange={this.onSelectLifeInsurance}
              >
                <option value="#">Select Life Insurance</option>
                {selectedLifeInsurance}
              </select>
            </div>
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Description</label>
              <FormControl
                autoFocus
                type="text"
                id="description"
                name="description"
                defaultValue={this.state.selectedLifeInsurance.description}
                onChange={this.onChangeLifeInsuranceData}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Arabic Description</label>
              <FormControl
                autoFocus
                type="text"
                id="ar_description"
                name="ar_description"
                defaultValue={this.state.selectedLifeInsurance.ar_description}
                onChange={this.onChangeLifeInsuranceData}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateLifeInsurance}
            >
              Update
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
